import React, { useEffect, useState } from 'react';
import { Modal, Badge, Row, Col, Card, Button } from 'react-bootstrap';
import './UpdatePreviewModal.css';

const UpdatePreviewModal = ({ show, onHide, previewPayload, submitting, onConfirm }) => {
  const detectDark = () => (typeof document !== 'undefined' && document.body.classList.contains('dark-theme'));
  const [isDark, setIsDark] = useState(detectDark());

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'class') setIsDark(detectDark());
      });
    });
    if (typeof document !== 'undefined') {
      observer.observe(document.body, { attributes: true });
    }
    return () => observer.disconnect();
  }, []);

  const modalClass = isDark ? 'update-preview-modal dark' : 'update-preview-modal';

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className={modalClass} contentClassName="update-preview-modal__content">
      <Modal.Header closeButton className="update-preview-modal__header">
        <Modal.Title>Confirmar envio de atualização</Modal.Title>
      </Modal.Header>
      <Modal.Body className="update-preview-modal__body">
        {previewPayload ? (
          <div className="update-preview-modal__scroll">
            <div className="mb-2 d-flex flex-wrap gap-2 align-items-center">
              <Badge bg="info" className="shadow-sm">Versão alvo: {previewPayload.lastVersion || 'N/I'}</Badge>
              <Badge bg={previewPayload.allEquipmentsUpdate ? 'success' : 'secondary'} className="shadow-sm">
                Todos selecionados: {previewPayload.allEquipmentsUpdate ? 'Sim' : 'Não'}
              </Badge>
              <Badge bg="secondary" className="shadow-sm">Estados: {previewPayload.statesUpdate?.length || 0}</Badge>
              <Badge bg="secondary" className="shadow-sm">Cidades: {previewPayload.citysUpdate?.length || 0}</Badge>
              <Badge bg="secondary" className="shadow-sm">Equipamentos: {previewPayload.equipments?.length || 0}</Badge>
            </div>
            <Row className="g-3 mb-2">
              <Col md={4}>
                <Card className="shadow-sm border-0 update-preview-modal__card">
                  <Card.Body className="py-2">
                    <div className="text-muted small">Versão alvo</div>
                    <div className="fw-bold">{previewPayload.lastVersion || 'N/I'}</div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="shadow-sm border-0 update-preview-modal__card">
                  <Card.Body className="py-2">
                    <div className="text-muted small">Todos selecionados</div>
                    <div className="fw-bold">
                      <Badge bg={previewPayload.allEquipmentsUpdate ? 'success' : 'warning'} text={previewPayload.allEquipmentsUpdate ? undefined : 'dark'}>
                        {previewPayload.allEquipmentsUpdate ? 'Sim' : 'Não'}
                      </Badge>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="shadow-sm border-0 update-preview-modal__card">
                  <Card.Body className="py-2">
                    <div className="text-muted small">Quantidades</div>
                    <div className="fw-bold">{previewPayload.statesUpdate?.length || 0} estados</div>
                    <div className="fw-bold">{previewPayload.citysUpdate?.length || 0} cidades</div>
                    <div className="fw-bold">{previewPayload.equipments?.length || 0} equipamentos</div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div className="mt-2">
              <div>
                <div className="text-muted small mb-1">Equipamentos ({previewPayload.equipments?.length || 0})</div>
                <div className="update-preview-modal__equipments-box">
                  <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 8 }}>
                    {(() => {
                      const arr = previewPayload.equipments || [];
                      const shown = arr.slice(0, 50);
                      const rest = arr.length - shown.length;
                      return (
                        <>
                          {shown.map((id) => (
                            <div key={id} className="px-2 py-1 update-preview-modal__eq-chip">{id}</div>
                          ))}
                          {rest > 0 && <div className="px-2 py-1 text-center update-preview-modal__eq-chip more">+{rest} mais</div>}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>Preparando dados...</div>
        )}
      </Modal.Body>
      <Modal.Footer className="update-preview-modal__footer">
        <Button variant={isDark ? 'outline-light' : 'secondary'} onClick={onHide} disabled={submitting}>Cancelar</Button>
        <Button variant="success" onClick={onConfirm} disabled={submitting}>
          {submitting ? 'Enviando...' : 'Confirmar envio'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdatePreviewModal;